// global
import React from 'react';
// components
import CylinderIcon from 'app/ui/pages/monitor/monitorTableBody/monitorTableRow/cylinderIcons/cylinderIcon/CylinderIcon';
import CylinderGroupByStatus from "app/ui/pages/monitor/monitorTableBody/monitorTableRow/cylinderIcons/cylinderGroupByStatus/CylinderGroupByStatus";
import CylinderGroup from "app/ui/pages/monitor/monitorTableBody/monitorTableRow/cylinderIcons/cylinderGroup/CylinderGroup.jsx";
import ContextualHelp from "app/ui/commons/contextualHelp/ContextualHelp";
// utils
// import _ from 'lodash';
// stylesheet
import styles from "./CylinderIcons.module.scss";

const CylinderIcons = ({ cylinderTypes, inAlert, cylinderSize }) => {
  const ghostCylinders = cylinderTypes.ghostCylinders ?? [];
  const commonCylinders = (cylinderTypes.commonCylinders ?? []).map(cyl => ({
    ...cyl,
    cylinderMode: 'common',
  }));

  const totalCylinders = ghostCylinders.length + commonCylinders.length;

  const renderGroupedCylinders = () => (
    <div className={styles.cylinderWrapper}>
      {CylinderGroupByStatus({
        ghostCylinders,
        commonCylinders,
        cylinderSize,
        inAlert,
      })}
      <ContextualHelp
        type="info"
        header="Cilindros do Paciente"
        content={CylinderGroup({
          ghostCylinders,
          commonCylinders,
          cylinderSize,
          inAlert,
        })}
        size="tiny"
        contentSize="200"
      />
    </div>
  );

  const renderSimpleCylinders = () => {
    const cylindersToRender = [...ghostCylinders, ...commonCylinders].slice(0, 5);
    return cylindersToRender.map((cylinder, index) => (
      <CylinderIcon
        key={cylinder.id ?? index}
        state={cylinder.state}
        ghostState={cylinder.ghostState}
        pressure={cylinder.pressure}
        inAlert={inAlert}
        cylinderSize={cylinderSize}
        cylinderMode={cylinder.cylinderMode}
      />
    ));
  };

  const MAX_NUMBER_ICONS_DISPLAYED = 5;
  const shouldRenderGroupedCylinders = totalCylinders > MAX_NUMBER_ICONS_DISPLAYED;

  return shouldRenderGroupedCylinders ? renderGroupedCylinders() : renderSimpleCylinders();
};

export default CylinderIcons;
